import dayAreaShipping from './day-area-shipping.container';

export default dayAreaShipping;
